import { ExternalConnection } from '@griply/types';
import { useRedirectToExternalAuthMutation } from 'shared/hooks/queries/use-redirect-to-external-auth-mutation';

export const useReconnectExternalConnection = (
  connection: ExternalConnection,
) => {
  const { mutate, isPending } = useRedirectToExternalAuthMutation();

  const onReconnect = () =>
    mutate({
      provider: connection.provider,
      email: connection.providerInfo.email,
    });

  return { onReconnect, isPending };
};
